import React, { Fragment } from "react";
import { connect } from "react-redux";

import PeriodDatesPickerContainer from "./../PeriodDatesPickerContainer";
import GlobalKpiView from "../../components/DashboardViews/GlobalKpiView";
import { getCurrentHomeData } from "../../selectors";
import CountUp from "react-countup";
import { FormattedMessage } from "react-intl";

const HomeContainer = props => {
  const data = props.data || {};
  const globalData = data.global || {};
  const retailersData = data.retailers || {};
  const sectorsData = data.sectors || {};
  const brandsData = data.brands || {};
  const kpi = props.kpi || {};
  const title = kpi && kpi.long_label ? props.kpi.long_label : "";
  const kpiNotPercent = kpi.format === "Pourcentage" ? "" : "p-pdg-0";
  return (
    <Fragment>
      <div className="p-al-full p-stats-home-container">
        <div className="p-al-full p-w-3-5 p-content-item p-stats-home-item p-scroll-x">
          <div className="p-w-1-3 p-stats-home-item-block">
            <GlobalKpiView
              circleTitle={
                <FormattedMessage id={"DN"} defaultMessage={"DN"}>
                  {txt => <React.Fragment>{txt}</React.Fragment>}
                </FormattedMessage>
              }
              kpi={{
                format: "Pourcentage"
              }}
              data={null}
              loading={null}
            />
          </div>
          <div className="p-w-1-3 p-stats-home-item-block">
            <GlobalKpiView
              circleTitle={
                <FormattedMessage id={"TAUX DE RUPTURE"} defaultMessage={"TAUX DE RUPTURE"}>
                  {txt => <React.Fragment>{txt}</React.Fragment>}
                </FormattedMessage>
              }
              kpi={{
                format: "Pourcentage"
              }}
              data={null}
              loading={null}
            />
          </div>
          <div className="p-w-1-3 p-stats-home-item-block">
            <GlobalKpiView
              circleTitle={
                <FormattedMessage id={"PSR"} defaultMessage={"PSR"}>
                  {txt => <React.Fragment>{txt}</React.Fragment>}
                </FormattedMessage>
              }
              kpi={{
                format: "Pourcentage"
              }}
              data={null}
              loading={null}
            />
          </div>
        </div>
        <div className="p-w-2-5" style={{ overflow: "hidden" }}>
          <div className="p-mrg-bot-s p-al-c-center">
            <PeriodDatesPickerContainer />
          </div>
          <div className="p-al-full" style={{ height: "calc(100% - 42px)", overflow: "hidden" }}>
            <div className="p-content-item p-stats-home-item p-w-1-2 p-pdg-0">
              <div className="p-al-r-center p-w-h-100">
                <div className="p-al-r-full-center p-w-1-3" style={{ backgroundColor: "#54CD98", width: "34%" }}>
                  <div className="icon-dn" style={{ fontSize: "4vh", color: "#fff" }} />
                </div>
                <div className="p-al-r-full-center p-w-2-3 p-pdg-full">
                  <div>
                    <h2 className="p-stats-home-item-title">
                      {
                        <FormattedMessage id={"Visites"} defaultMessage={"Visites"}>
                          {txt => <React.Fragment>{txt}</React.Fragment>}
                        </FormattedMessage>
                      }
                    </h2>
                    <div
                      className="p-txt-center"
                      style={{
                        fontWeight: "bold",
                        marginTop: "5%",
                        fontSize: "4vh"
                      }}
                    >
                      <CountUp start={0} end={2812} duration={3} separator=" " style={{ fontSize: "3vh" }} />

                      <div className="icon-arrow-up" style={{ fontSize: "3vh", marginTop: "20%" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-content-item p-stats-home-item p-w-1-2 p-pdg-0">
              <div className="p-al-r-center p-w-h-100">
                <div className="p-al-r-full-center p-w-1-3" style={{ backgroundColor: "#FEA701", width: "34%" }}>
                  <div className="icon-pdl" style={{ fontSize: "4vh", color: "#fff" }} />
                </div>
                <div className="p-al-r-full-center p-w-2-3 p-pdg-full">
                  <div>
                    <h2 className="p-stats-home-item-title">PDL</h2>
                    <div
                      className="p-txt-center"
                      style={{
                        fontWeight: "bold",
                        marginTop: "5%",
                        fontSize: "4vh"
                      }}
                    >
                      <CountUp start={0} end={"17.6"} duration={3} separator=" " style={{ fontSize: "3vh" }} />

                      <div className="icon-equal" style={{ fontSize: "3vh", marginTop: "20%" }} />
                    </div>
                  </div>
                </div>
              </div>
              ck
            </div>
          </div>
        </div>
      </div>
      <div className="p-al-full p-stats-home-container">
        <div className="p-w-1-2 p-content-item p-stats-home-item">Histo</div>
        <div className="p-w-1-2 p-content-item p-stats-home-item">Courbe</div>
      </div>
      <div className="p-al-full p-stats-home-container" style={{ marginBottom: 0 }}>
        <div className="p-w-1-2 p-content-item p-stats-home-item">Courbe</div>
        <div className="p-w-1-2 p-content-item p-stats-home-item">Histo</div>
      </div>
    </Fragment>
  );
};
//REDUX
const mapStateToProps = state => {
  const stats = state.stats || {};
  return {
    graphLoading: state.stats.graphLoading,
    period: stats.period,
    data: getCurrentHomeData(state)
    //kpi: getKpiSelected(state),
    // data: dataprice,
    // kpi: kpiprice,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);



// WEBPACK FOOTER //
// src/modules/stats/containers/views/HomeContainer.js